import './app.scss';

import { useRoutes } from 'routes/routes';

export const App = () => useRoutes();
